module.exports = __webpack_public_path__ + "img/header.52627b4f.png";